import { FC } from 'react';
import { Block } from './Blur.style';

export const Blur: FC<{ elementsCount?: number }> = ({ children }) => {
  return <Block>{children}</Block>;
};
